import { render, staticRenderFns } from "./TakipEkAlanTuruForm.vue?vue&type=template&id=05637db1"
import script from "./TakipEkAlanTuruForm.vue?vue&type=script&lang=ts"
export * from "./TakipEkAlanTuruForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports